import React from "react";
import { Link, useLocation } from "react-router-dom";
import { TopBarWrapper, ButtonTab, CloseButton } from "./TopBarLoginStyles";

const TopBarLogin = () => {
  const location = useLocation();

  const isLogin = location.pathname === "/login";
  const isRegister = location.pathname === "/register";

  return (
    <TopBarWrapper>
      <div style={{ display: "flex", gap: "1rem" }}>
        <Link to="/login" style={{ textDecoration: "none" }}>
          <ButtonTab active={isLogin}>Intră în cont</ButtonTab>
        </Link>
        <Link to="/register" style={{ textDecoration: "none" }}>
          <ButtonTab active={isRegister}>Cont nou</ButtonTab>
        </Link>
      </div>
      <Link to="/" style={{ textDecoration: "none" }}>
        <CloseButton>&times;</CloseButton>
      </Link>
    </TopBarWrapper>
  );
};

export default TopBarLogin;
